import React from 'react';
import { connect } from 'react-redux';
import { useResources } from '~app/BundleProvider';
import SnapChart from './SnapChart';

const RightSide = ({ version }) => {
  const r = useResources();
  return (
    <div className="RightSide">
      {version === "standard"
        ? <SnapChart src={r("chart-detailed.svg")}/>
        : <SnapChart src={r("chart-basic.svg")}/>
      }
    </div>
  );
};
const mapStateToProps = ({ app }) => ({ version: app.version });

export default connect(mapStateToProps)(RightSide);



// WEBPACK FOOTER //
// ./src/pages/Main/RightSide.js